import { gql } from 'apollo-boost';
const queryInterestList = `
    {
        interests {
            id
            name
    		    active
    		    visible
    		    generalInterest
    		    clientId
        }
    }
`;
const updateInterestMutation = gql `
	mutation ($keywords: JSONString!, $name: String!) {
		createUpdateInterest(keywords: $keywords, name: $name) {
			ok
			message
			interest {
				id
				name
				keywords
			}
		}
	}
`;
const getInterestOverlapQuery = gql `
	{
		interestOverlap {
			id
			clientId
			generalInterest1
			generalInterest2
			interest1
			interest2
			overlap
			relevance
			updatedAt
		}
	}
`;
const getFileContentQuery = gql `
	{
		getPersonaInterest(fileName: interests_alza)
	}
`;
const getFileContentInterestsQuery = gql `
	{
		getInterestContent {
		  TPDmpId
		  account
		}
	}
`;
const getPersonaExplorerSocDemo = gql `
  {
    getPersonaExplorerSocdemo {
      id
      targetId
      socDemoId
      value
      clientLabel
    }
  }
`;
const getPersonaExplorerInterests = gql `
  {
    getPersonaExplorerInterests {
      targetId
      interestName
      coefficient
      clientLabel
    }
  }
`;
const getTrackingPointsQuery = gql `
	{
		trackings {
			tpId
			tpName
			tpCount
			updatedAt
		}
	}
`;
export { queryInterestList, updateInterestMutation, getInterestOverlapQuery, getFileContentQuery, getTrackingPointsQuery, getFileContentInterestsQuery, getPersonaExplorerInterests, getPersonaExplorerSocDemo };
